module.exports = __webpack_public_path__ + "img/ticket.8c17f9bc.svg";